<template>
  <div class="overseas_enthusiasm" id="detail_cont">
    <div class="echarts_show" id="echarts_show">
      <!-- 品牌媒体关注分析 -->
      <BrandMedia class="item_components" id="1" v-show="analysis" />
      <!-- 用户关注音量趋势 -->
      <VolumeTrends class="item_components" id="2" v-show="userAttention" />
      <!-- 情绪分布 -->
      <EmotionalDistribution class="item_components" id="3" v-show="distribution" />
      <!-- 情绪运动 -->
      <EmotionalMovements class="item_components" id="4" v-show="movements" />
      <!-- 舆论活动分析 -->
      <Analysis class="item_components" id="5" v-show="publics" />
      <!-- 流行的词云 -->
      <WordCloud class="item_components" id="6" v-show="wordCloud" />
      <!-- 区域分析 -->
      <HeatAnalysis class="item_components" id="7" v-show="regional" />
      <!-- 品牌排名 -->
      <BrandRank class="item_components" id="8" v-show="brandranking" />
      <!-- 行业地域分布 -->
      <!-- <IndustryLocal class="item_components industry" id="9" v-show="industryregion" /> -->
      <!-- 行业活跃度 -->
      <!-- <IndustryActivity class="item_components" id="10" v-show="industryactivity" /> -->
    </div>
    <div class="floor">
      <div class="fixed_style" id="floorNavList">
        <!-- 右侧滑点 -->
        <el-timeline class="nav-list">
          <el-timeline-item
            class="nav-list-item"
            v-for="(activity, index) in activities"
            :key="index"
            :icon="activity.icon"
            :type="activity.type"
            :color="activity.color"
            :size="activity.size"
            @click.native="setFloorNavMountClick(index)"
            :timestamp="activity.timestamp"
          >
            <a :class="{fontColor:activity.contentColor}">{{activity.content}}</a>
          </el-timeline-item>
        </el-timeline>
      </div>
    </div>
  </div>
</template>

<script>
import BrandMedia from "./overseas_components/BrandMedia";
import VolumeTrends from "./overseas_components/VolumeTrends";
import EmotionalDistribution from "./overseas_components/EmotionalDistribution";
import EmotionalMovements from "./overseas_components/EmotionalMovements";
import Analysis from "./overseas_components/Analysis";
import WordCloud from "./overseas_components/WordCloud";
import HeatAnalysis from "./overseas_components/HeatAnalysis";
import BrandRank from "./overseas_components/BrandRank";
// import IndustryLocal from "./overseas_components/IndustryLocal";
// import IndustryActivity from "./overseas_components/IndustryActivity";
var TIMER = null;
export default {
  name: "home",
  data() {
    return {
      analysis: false,
      userAttention: false,
      distribution: false,
      movements: false,
      publics: false,
      wordCloud: false,
      fontColor: false,
      regional: false,
      brandranking: false,
      industryregion: false,
      industryactivity: false,
      activities: [],
      content: ""
    };
  },
  components: {
    //品牌媒体关注分析
    BrandMedia,
    //用户关注音量趋势
    VolumeTrends,
    //情绪分布
    EmotionalDistribution,
    //情绪运动
    EmotionalMovements,
    //舆论活动分析
    Analysis,
    //流行的词云
    WordCloud,
    //区域热分析
    HeatAnalysis,
    //品牌排名
    BrandRank,
    //行业地域分布
    //IndustryLocal,
    //行业活跃度
    //IndustryActivity
  },
  created() {
    const power = JSON.parse(localStorage.getItem("power"));
    if (power !== null && power.length > 0) {
      power.map(item => {
        item.childPermission.map(val => {
          if (val.id === 3) {
            val.childPermission.filter(value => {
              switch (value.id) {
                case 9:
                  this.analysis = true;
                  break;
                case 10:
                  this.userAttention = true;
                  break;
                case 11:
                  this.distribution = true;
                  break;
                case 12:
                  this.movements = true;
                  break;
                case 13:
                  this.publics = true;
                  break;
                case 14:
                  this.wordCloud = true;
                  break;
                case 15:
                  this.regional = true;
                  break;
                case 16:
                  this.brandranking = true;
                  break;
                // case 18:
                //   this.industryregion = true;
                //   break;
                // case 19:
                //   this.industryactivity = true;
                //   break;
                default:
                  break;
              }

              this.activities.push({
                content: value.url,
                color: "",
                contentColor: false
              });
              
            });
          }
        });
      });
    }
   
    for (var i = 0; i < this.activities.length; i++) {
      for (var j = i + 1; j < this.activities.length; j++) {
        if (this.activities[i].content == this.activities[j].content) {
          this.activities.splice(j, 1);
          j--;
        }
      }
    }
    this.activities.splice(8,10);
    //console.log(this.activities.splice(8,10),'锚点&&&')
    this.activities.map((item, index) => {
      switch (index) {
        case 0:
          item.content = "Trend Analysis of Brand Volume";
          break;
        case 1:
          item.content = "Trend of User's Attention";
          break;
        case 2:
          item.content = "Emotion Distribution";
          break;
        case 3:
          item.content = "Emotion Trend";
          break;
        case 4:
          item.content = "Public Opinion Activation";
          break;
        case 5:
          item.content = "Hot-word Cloud";
          break;
        case 6:
          item.content = "Region Volume Analysis";
          break;
        case 7:
          item.content = "Brand Popularity Ranking";
          break;
        // case 8:
        //   item.content = "Industry Distribution";
        //   break;
        // default:
        //   item.content = "Industry Vitality";
        //   break;
      }
      return item;
    });
    
  },
  methods: {
    //点击锚点
    setFloorNavMountClick(index) {
      //获取左侧内容的高度
      const jump = document
        .getElementById("echarts_show")
        .getElementsByClassName("item_components");
      //获取需要滚动的距离
      let scrollHeight = jump[index].offsetTop;

      this.activities.map((item, i) => {
        item.color = "";
        item.contentColor = false;
      });
      this.activities[index].color = "#0078FF";
      this.activities[index].contentColor = true;
      document.getElementById("detail_content").scrollTop = scrollHeight;

      document.documentElement.scrollTop = scrollHeight;
    },
    /**
     * 监听窗口滚动楼层导航动态定位
     */
    floorSrcollAddEventListener() {
      let allItem = Array.from(document.getElementsByClassName("title"));
      let scrollTop =
        document.documentElement.scrollTop ||
        document.getElementById("detail_content").scrollTop;
      // console.log(scrollTop,'滚动条距离浏览器的距离')
      allItem.map((item, index) => {
        if (
          item.offsetTop - scrollTop <= 50 &&
          item.offsetTop - scrollTop >= 0
        ) {
          this.activities.map(item => {
            item.color = "";
            item.contentColor = false;
          });
          this.activities[index] ? this.activities[index].color = "#0078FF" : "";
          this.activities[index] ? this.activities[index].contentColor = true : "";
        } else if (
          item.offsetTop - scrollTop >= 90 &&
          item.offsetTop - scrollTop <= 350
        ) {
          this.activities.map(item => {
            item.color = "";
            item.contentColor = false;
          });
          this.activities[index] ? this.activities[index].color = "#0078FF" : "";
          this.activities[index] ? this.activities[index].contentColor = true : "";
        }
      });
    },
    /* 清空楼层效果设置 */
    clearnAllset() {
      this.activities.map(item => {
        item.color = "";
        item.contentColor = false;
      });
    }
  },
  mounted() {
    document
      .getElementById("detail_content")
      .addEventListener("scroll", this.floorSrcollAddEventListener);
  },
  destroyed() {
    /* 清空楼层效果设置 */
    this.clearnAllset();
  },
  watch: {
    activities: {
      handler(val) {
        this.activities = val;
        
      },
      deep: true
    }
  }
};
</script>

<style scoped>
.fontColor {
  color: #0078ff;
}
.overseas_enthusiasm > div {
  display: inline-block;
  margin-bottom: 30px;
  vertical-align: top;
}
.fixed_style {
  position: fixed;
  top: 20%;
  right: 3%;
  /* display: none; */
}
.fixed_style >>> .el-timeline-item {
  padding-bottom: 15px !important;
}
.floor {
  width: 170px;
}
.echarts_show {
  width: calc(100% - 170px);
}
.floor >>> .el-timeline-item__wrapper {
  cursor: pointer;
  width: 155px;
  font-family: RCR;
}
.industry >>> .pie_style {
  left: 2% !important;
}
@media screen and (max-width: 1060px) {
  .fixed_style {
    position: relative;
    top: 20%;
    display: none;
    right: 3%;
  }
  .echarts_show {
    width: 100%;
  }
}
</style>